import { Table } from "antd";
import styled from "styled-components";

export const Container = styled.div`
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: #f8f9fd;
`;
export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 2rem;
`;
export const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  & > h1 {
    margin: 0;
    color: #123559;
    margin-left: 1rem;
  }
`;
export const ContainerTable = styled.div`
  padding: 1rem 2rem;
  flex: 1;
  position: relative;
`;
export const ContainerSearce = styled.div`
  display: flex;
  align-items: center;
  & > p {
    margin: 0;
    color: #123559;
    margin-right: 1rem;
  }
`;
export const SearchInput = styled.input`
  border: none;
  border-radius: 2rem;
  padding: 0.5rem 1rem;
  outline: none;
  ::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    font-size: 0.75rem;
    color: #ddd;
  }
  ::-moz-placeholder {
    /* Firefox 19+ */
    font-size: 0.75rem;
    color: #ddd;
  }
  :-ms-input-placeholder {
    /* IE 10+ */
    font-size: 0.75rem;
    color: #ddd;
  }
  :-moz-placeholder {
    /* Firefox 18- */
    font-size: 0.75rem;
    color: #ddd;
  }
`;

export const TdPhone = styled.p`
  text-align: center;
  min-width: 100px;
  margin: 0;
`;

export const TdEmail = styled.p`
  text-align: center;
  min-width: 200px;
  margin: 0;
`;

export const ComponentGroupButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CenterColumns = styled.div`
  text-align: center;
  font-size: 1rem;
`;

export const CustomTable = styled(Table)`
  & button.ant-pagination-item-link {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
